<div class="container-fluid content-padded">
  <div class="row forms-row">
    <!-- Main Forms -->
    <span *ngIf="isLoadingForms" class="title loading"></span>
    <span *ngIf="isLoadingForms" class="form-click loading"></span>
    <span *ngIf="isLoadingForms" class="title loading"></span>
    <span *ngIf="isLoadingForms" class="form-click loading"></span>
    <span *ngIf="isLoadingForms" class="title loading"></span>
    <div class="main-form-flex" *ngIf="showTrackerForm">
      <div class="main-form-container tracker-form" *ngIf="!isLoadingForms">
        <!-- Title -->
        <div class="title">
          <img *ngIf="!isLoadingForms" [src]="clipboardImg" class="title-image clipboard" alt="">
          <h2 class="title-text" *ngIf="!isLoadingForms">
            {{blocksConfig.symptomTracker.name | translate}}
          </h2>
        </div>

        <p title="{{'Keep a record of treatment-related side effects for you and your healthcare team.' | translate}}" class="description" *ngIf="!isLoadingForms">{{'Keep a record of treatment-related side effects for you and your healthcare team.' | translate}}</p>
        <!-- Button Link -->
        <div class="interaction-section">
          <button *ngIf="!isLoadingForms && trackerSurveyAvailable" (click)="goToForm(trackerSurvey.currentSurvey.formId, true)"
            class="btn btn-csc-primary">
            {{getTrackerSurveyState}}
            <img [src]="rightArrowImg" class="arrow-button rightarrow" alt="">
          </button>
          <a *ngIf="res?.trackerSurveyDashboardView?.completedSurveys.length > 0" class="view-history-link" hidden (click)="viewHistory(res.trackerSurveyDashboardView.completedSurveys, this.blocksConfig.symptomTracker)">{{'View History' | translate}}</a>
        </div>
      </div>
    </div>
    <!-- /Main Forms -->

    <div class="secondary-form-flex" *ngIf="!isLoadingForms && showDistressScreener">
      <div class="main-form-container distress-screener">
        <div class="title">
          <img [src]="cerLogo" class="title-image icon cer" alt="" onerror="this.onerror=null;this.src='logoCER.png';">

        </div>
        <div class="survey-body">
          <p title="{{'Help us help you by sharing how you’re feeling and what’s been going on with you and your healthcare.' | translate}}" class="description"
            *ngIf="!isLoadingForms">{{'Help us help you by sharing how you’re feeling and what’s been going on with you and your healthcare.' | translate}}</p>

        </div>
        <div class="interaction-section">

          <button *ngIf="res.distressScreenerDashboardView?.formInstanceId"  (click)="goToForm(res.distressScreenerDashboardView.formInstanceId)"

                  class="btn btn-csc-primary">
            {{'Start' | translate}}
            <img [src]="rightArrowImg" class="arrow-button rightharrow" alt="">
          </button>
          <a *ngIf="res.distressScreenerDashboardView?.completedSurveys?.length > 0" class="btn btn-csc-primary" (click)="viewHistory(res.distressScreenerDashboardView.completedSurveys, this.blocksConfig.distressScreener)" hidden>{{'View History' | translate}}</a>
        </div>
      </div>
    </div>



    <div class="secondary-form-flex" *ngIf="!isLoadingForms && res.customSurveysDashboardView && res.customSurveysDashboardView.formInstanceId">
      <div class="main-form-container other-surveys">
        <div class="title">
          <i class="fa fa-check-square icon title-image" aria-hidden="true"></i>
          <h2 class="title-text" *ngIf="!isLoadingForms">
            {{res.customSurveysDashboardView.formName}}
          </h2>
        </div>
        <div class="survey-body">
          <p class="description" *ngIf="res.customSurveysDashboardView.formInstanceId && res.customSurveysDashboardView.formDescription">{{res.customSurveysDashboardView.formDescription}}</p>
          <div class="interaction-section">
            <button *ngIf="res.customSurveysDashboardView?.formInstanceId" (click)="goToForm(res.customSurveysDashboardView.formInstanceId)" class="btn button form form-click">
              {{'Start' | translate}}
              <img [src]="rightArrowImg" class="arrow-button rightharrow" alt="">
            </button>

            <a *ngIf="res.customSurveysDashboardView?.completedSurveys.length > 0" class="view-history-link" (click)="viewHistory(res.customSurveysDashboardView.completedSurveys, this.blocksConfig.custom)" hidden>{{'View History' | translate}}</a>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div class="row">
    <app-blogs-list *ngIf="res"></app-blogs-list>
  </div>
  <div class="row thumbnails">
    <div class="col-md-6" *ngIf="isAboutIoAvailable">
      <app-thumb-learn-about-io [routerLink]="['/learn-about-io']"></app-thumb-learn-about-io>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12" *ngIf="isLivingCancerAvailable">
      <app-thumb-living-with-cancer></app-thumb-living-with-cancer>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12" *ngIf="isRegistryAvailable">
      <app-thumb-join-today></app-thumb-join-today>
    </div>
  </div>
</div>
